import { formatDollarsFromString } from '@utils/formatNumbers';

export const getLowestMonthlyPremiumFromPlans = (plans) =>
  formatDollarsFromString(
    plans.reduce((prev, curr) => (parseInt(prev.averagePremium, 10) < parseInt(curr.averagePremium, 10) ? prev : curr))
      .averagePremium
  );

export const randomizeContent = (options, seed) => {
  const generated = Object.keys(options).reduce((acc, el) => {
    const randomSentence = options[el][seed.length % options[el].length];
    return { ...acc, [el]: randomSentence };
  }, {});

  return generated;
};
